import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import axios, { API } from "@/lib/api";
import StatusBadge from "@/components/shared/StatusBadge";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

function formatDate(d) { return d ? new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "-"; }

export default function AgentJamaah() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/agen/jamaah`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="agent-jamaah-page" className="space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Jamaah Saya</h1>
        <p className="text-sm text-[#64748B]">Daftar jamaah yang mendaftar melalui kode referral Anda.</p>
      </div>

      {items === null ? <LoadingScreen /> : items.length === 0 ? (
        <EmptyState icon={Users} title="Belum ada jamaah" description="Bagikan kode referral Anda agar jamaah baru tercatat di sini." />
      ) : (
        <div className="overflow-x-auto rounded-xl border border-amber-100 bg-white">
          <Table data-testid="agent-jamaah-table">
            <TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>HP</TableHead><TableHead>Tanggal Daftar</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
            <TableBody>
              {items.map((j) => (
                <TableRow key={j.id} data-testid={`agent-jamaah-row-${j.id}`}>
                  <TableCell className="font-medium text-[#1F2937]">{j.name}</TableCell>
                  <TableCell className="text-[#64748B]">{j.phone}</TableCell>
                  <TableCell className="text-[#64748B]">{formatDate(j.created_at)}</TableCell>
                  <TableCell><StatusBadge status={j.status} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
